import { BLACK_300, BLACK_900 } from '../colors';
var skeletonLoaderLightConfig = {
  theme: 'light',
  type: 'heading',
  color: BLACK_300,
  fullWidth: false,
  animationDuration: 1500,
  showTopMargin: false,
  showLeftMargin: false,
  showRightMargin: false,
  loaderType: 'gradient',
  gradientType: 'default',
  config: {
    heading: {
      height: 20,
      width: 333,
      borderRadius: 'BORDER_RADIUS_4'
    },
    badge: {
      height: 36,
      width: 88,
      borderRadius: 'BORDER_RADIUS_100'
    },
    'list-item': {
      height: 56,
      width: 333,
      borderRadius: 'BORDER_RADIUS_8'
    },
    'card-small': {
      height: 76,
      width: 375,
      borderRadius: 'BORDER_RADIUS_8'
    },
    'card-medium': {
      height: 128,
      width: 375,
      borderRadius: 'BORDER_RADIUS_8'
    },
    'card-large': {
      height: 256,
      width: 375,
      borderRadius: 'BORDER_RADIUS_8'
    },
    'square-card': {
      height: 160,
      width: 150,
      borderRadius: 'BORDER_RADIUS_10'
    },
    title: {
      height: 19,
      width: 296,
      borderRadius: 'BORDER_RADIUS_10'
    },
    'list-item-small': {
      height: 40,
      width: 296,
      borderRadius: 'BORDER_RADIUS_10'
    },
    circle: {
      height: 46,
      width: 46,
      borderRadius: 'BORDER_RADIUS_100'
    },
    'list-item-medium': {
      height: 40,
      width: 303,
      borderRadius: 'BORDER_RADIUS_10'
    }
  }
};
var skeletonLoaderDarkConfig = Object.assign(Object.assign({}, skeletonLoaderLightConfig), {
  theme: 'dark',
  color: BLACK_900
});
export default {
  light: skeletonLoaderLightConfig,
  dark: skeletonLoaderDarkConfig,
  white: skeletonLoaderLightConfig
};